import { render, staticRenderFns } from "./SvgDropDown.vue?vue&type=template&id=2ded12be"
import script from "./SvgDropDown.vue?vue&type=script&lang=js"
export * from "./SvgDropDown.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports